import React from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";

import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";
import "./NewSampleRetestConfirmationModal.css";

export default function NewSampleRetestConfirmationModal({
  testToRetest,
  currNumOfRetests,
  maxNumOfRetests,
  newSampleDate,
  onCancel,
  onConfirm,
  awaitingRetestRequest,
}) {
  const numberMap = ["first", "second", "third and final"];
  const testSet = new Set(testToRetest);
  const tests = Array.from(testSet);

  const testPills = tests.map((test, index) => (
    <span key={index} className="NewSampleRetestConfirmationModal__Pill">{test}</span>
  ));

  return (
    <Modal
      open
      maskClosable={false}
      closable={false}
      centered
      footer={null}
      wrapClassName="NewSampleRetestConfirmationModal"
      className="NewSampleRetestConfirmationModal"
      openAnim={false}
      width="496px"
    >
      <div className="NewSampleRetestConfirmationModal__Body">
        <span className="NewSampleRetestConfirmationModal__Heading">
          The sample will be retested for the following tests:
        </span>

        <div className="NewSampleRetestConfirmationModal__TestsSection">
          <span className="NewSampleRetestConfirmationModal__Label">Included Tests</span>
          {tests.length > 10 ? (
            <div className="NewSampleRetestConfirmationModal__PillsScroll">
              <StyledScrollbar>
                <div className="NewSampleRetestConfirmationModal__Pills">
                  {testPills}
                </div>
              </StyledScrollbar>
            </div>
          ) : (
            <div className="NewSampleRetestConfirmationModal__Pills">
              {testPills}
            </div>
          )}
        </div>

        <div className="NewSampleRetestConfirmationModal__Info">
          <span className="NewSampleRetestConfirmationModal__Note">
            {`Please note a maximum of ${maxNumOfRetests} retests allowed. This is your ${numberMap[currNumOfRetests]} request (${currNumOfRetests + 1}/${maxNumOfRetests}).`}
          </span>
          {newSampleDate && (
            <span className="NewSampleRetestConfirmationModal__DateNote">
              {`You will submit the new sample on ${newSampleDate.format("MM/DD/YYYY")}.`}
            </span>
          )}
        </div>
      </div>

      <div className="NewSampleRetestConfirmationModal__Footer">
        <Button
          type="default"
          onClick={onCancel}
          disabled={awaitingRetestRequest}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={onConfirm}
          loading={awaitingRetestRequest}
        >
          Submit
        </Button>
      </div>
    </Modal>
  );
}
